/**
 *
 * @param {Array} dataArray - array of user input objects
 * @param {string} fieldName - string of field name
 * @returns
 */

export default function (dataArray, fieldName) {
    return dataArray.find((field) => field.name === fieldName)?.value
}
